import { ChangeDetectionStrategy, Component, input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * ### **ValorationComponent**
 *
 * **Selector:** ``<app-valoration> ``
 *
 * Componente encargado de la logica y renderización de las valoraciones o comentarios, este componente se encuentra presente tanto en el perfil de la ciudad o el del geomarcador. */
@Component({
  selector: 'app-valoration',
  imports: [TranslateModule],
  templateUrl: './valoration.html',
  styleUrl: './valoration.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Valoration implements OnChanges {
  /** Variable que indica la cantidad de valoraciones o comentarios hechas a una ciudad o geomarcador, que sea @input() nos dice que la información llega desde un componente padre o externo*/
  readonly valuations = input.required<number>();

  /** Variable encargada de definir la palabra que acompaña a la cantidad de comentarios*/
  valorationText!: string;

  constructor() {}

  /**
   * Hook de angular encargado de la deteccion de cambios, en caso de haber uno ejecutara el metodo de getValorationText()
   * @param change
   */
  ngOnChanges(change: SimpleChanges): void {
    if (change['valuations']) {
      this.getValorationText();
    }
  }

  /**
   * metodo encargado de definir el nombre que acompañara a la cantidad de comentarios.
   */
  private getValorationText(): void {
    this.valorationText = this.valuations() > 1 ? 'valoraciones' : 'valoracion';
  }
}
